import $ from 'jquery';

import BaseVisualControlFactory from 'BaseVisualControlFactory.js';
import factoryService   from 'FactoryService.js';
import constants        from 'Constants.js';
import sequenceService  from 'SequenceService.js';

import ControlModel    from 'ControlModel.js';
import TimeInputControlView  from 'common-inputs/TimeInputControlView.js';


//=============================================================================
//
// Alfonso Cabral, February 4, 2016
//
//=============================================================================
class ControlInputTimeFactory extends BaseVisualControlFactory {

    constructor () {
        super();
    }

    createView( factoryKey, pos ) {

        const attributes = this.createChildAttributes( factoryKey, pos ) ;

        //adding silent(accessibility) to attributes.
        attributes.silent = false;
        attributes.styleColorText ='~inputTextColor';
        attributes.fontFamily = '~inputFont';
        attributes.fontSize = '~inputFont';
        attributes.textWeight = '~inputFont';
        attributes.textStyle  = '~inputFont';
        attributes.borderStyle= '~inputBorder';
        attributes.borderSize= '~inputBorder';
        attributes.cornerRadius= '~inputBorder';
        attributes.borderColor = '~inputBorderColor';
        attributes.styleBGColorText = '~inputBgColor';
        attributes.backgroundColor = '~inputBgColor';
        attributes.timeValue = '';
        attributes.showEmpty = 'true';
        attributes.hasSeconds = 'true';
        attributes.is24HourClock = 'true';
        attributes.resizePadding = 4;
        attributes.resizePaddingH = 0;
        attributes.specific = '';
        attributes.resizePadding = 2;
        attributes.specificDisplay = '';
        attributes.format = 'MM/DD/YYYY';
        attributes.minYear = '1900';
        attributes.maxYear = '2100';
		attributes.minWidth = 13;
		attributes.lowestHeight = 15;
        this.resolveForInitialMinHeight(attributes);
        //Property exclusive for the heigth of the arrows' image this will never change similar functionality like the player 
        attributes.imgHeight = 20;
        attributes.translateProps = [
            {key:"obligatoryMessage", label:"Mandatory Message"},
            {key:"toolTip", label:"Tooltip"},
            {key:"accessDesc", label:"Accessibility Description"},
        ];

        const view = new TimeInputControlView( { model: new ControlModel( attributes ),  el: $(constants.FORM_ID),
            pos: pos, factoryKey: factoryKey, id: attributes.id } );

        return view;
    }

}

const controlInputTimeFactory = new ControlInputTimeFactory();

export default controlInputTimeFactory;